var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BotaoVoltar',{attrs:{"url":'/Hospede/Menu'}}),_c('Subtitulo',{attrs:{"subtitulo":_vm.subtitulo}}),_c('CategoriaLista',{attrs:{"idpdv":_vm.$route.params.idpdv}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }